export default __webpack_public_path__ + "static/media/menu.97e83f5d.svg";